import {useEffect, useRef} from 'react';
import useConstCallback from './useConstCallback';

export type UseTimeoutParams = {
	timeout?: number;
};

export const useTimeout = ({timeout: _timeout}: UseTimeoutParams = {}) => {
	const timeoutRef = useRef<NodeJS.Timeout>();

	useEffect(() => {
		return () => {
			timeoutRef.current && clearTimeout(timeoutRef.current);
		};
	}, []);

	const cancelTimeout = useConstCallback(() => {
		timeoutRef.current && clearTimeout(timeoutRef.current);
	});

	const executeTimeout = useConstCallback(
		(cb: () => void, timeout?: number) => {
			timeout = timeout ?? _timeout ?? 0;
			cancelTimeout;
			timeoutRef.current = setTimeout(cb, timeout);
		},
	);

	return {
		cancelTimeout,
		executeTimeout,
	};
};
